const _platforms = {
  "Windows NT": "windows",
  Linux: "linux",
};

export const platforms = Object.values(_platforms);

export function getOS() {
  const userAgent = window.navigator.userAgent;

  for (const platform in _platforms) {
    if (userAgent.indexOf(platform) !== -1) {
      return _platforms[platform];
    }
  }
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * The height of the navbar depends of the current bootstrap version.
 * To avoid an issue of mismatching this value for our use case, this
 * function gets the current height of the navbar (also varies on the brand)
 * and sets it in a CSS variable.
 */
export function setNavbarHeightVariableValue() {

  const navEl = document.querySelector(".App nav");
  const navElHeight = getComputedStyle(navEl).height;

  document.documentElement.style.setProperty(
    "--navbar-height",
    navElHeight
  );

}

export const tabs = [
  { key: "packages", label: "Packages" },
  { key: "changelog", label: "Changelog" },
  { key: "deviceDescriptions", label: "Device Descriptions" },
  { key: "functionBlocks", label: "Function Blocks / Libraries" },
];
